import React from "react"
import PropTypes from "prop-types"
import { inject, observer } from "mobx-react"

import styles from "./style.module.css"

const logos = {
    splash: {
        on: require("./splash-on.svg"),
        off: require("./splash-off.svg"),
    },
    games: {
        on: require("./game-on.svg"),
        off: require("./game-off.svg"),
    },
    about: {
        on: require("./about-on.svg"),
        off: require("./about-off.svg"),
    }
}


const activeState = (active, target) => active === target ? "on" : "off"

const ScreenButton =
    inject(stores => ({
        ui: stores.navigation_store
    }))(
        observer(({ ui, screen }) => (
            <div
                className={[styles[screen], "clickable"].join(" ")}
                >
                <img
                    width="100%"
                    src={logos[screen][activeState(ui.activeScreen, screen)]}
                    alt={screen}

                    className="img-fluid" />
            </div>
        ))
    )

ScreenButton.wrappedComponent.propTypes = {
    screen: PropTypes.string.isRequired
}

export default ScreenButton


// WEBPACK FOOTER //
// ./src/components/simple/ScreenButton/index.js